export const E_INVOICE_FORM_ID = 'eInvoiceCarrierForm';
